import { render } from "./BookingSuccessWaitingList.vue?vue&type=template&id=2c46ae28"
import script from "./BookingSuccessWaitingList.vue?vue&type=script&lang=js"
export * from "./BookingSuccessWaitingList.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__